import React, { MutableRefObject } from 'react';
import { SwipeableHandlers } from 'react-swipeable';

import MediaImage from './MediaImage';
import MediaOther from './MediaOther';
import MediaVideo from './MediaVideo';
import MediaPages from './MediaPages';
import MediaAudio from './MediaAudio';
import { Media } from '../../store/modules/media-viewer/types';

/* eslint-disable @typescript-eslint/camelcase */

type Props = {
  media: Media;
  swipeable?: SwipeableHandlers;
  slideDirection: 'left' | 'right' | 'up' | 'down';
  isChangePreviewMedia: number | null;
  refPreviewContent: MutableRefObject<HTMLDivElement | null>;
};

/*
media_type_id:
  0 : "Other"
  1 : "Image"
  2 : "Video"
  3 : "Audio"
  4 : "Paged"
*/

const MediaPreview = ({ media, swipeable, slideDirection, isChangePreviewMedia, refPreviewContent }: Props) => {

  switch (media.typeId) {
    case 0:
      return (
        <MediaOther
          media={media}
          swipeable={swipeable}
          slideDirection={slideDirection}
          isChangePreviewMedia={isChangePreviewMedia}
        />
      );

    case 1:
      return (
        <MediaImage
          media={media}
          swipeable={swipeable}
          slideDirection={slideDirection}
          isChangePreviewMedia={isChangePreviewMedia}
        />
      );

    case 2:
      return (
        <MediaVideo
          media={media}
          swipeable={swipeable}
          slideDirection={slideDirection}
          isChangePreviewMedia={isChangePreviewMedia}
          refPreviewContent={refPreviewContent}
        />
      );

    case 3:
      return (
        <MediaAudio
          media={media}
          swipeable={swipeable}
          slideDirection={slideDirection}
          isChangePreviewMedia={isChangePreviewMedia}
          refPreviewContent={refPreviewContent}
        />
      );

    case 4:
      return (
        <MediaPages
          media={media}
          swipeable={swipeable}
          slideDirection={slideDirection}
          isChangePreviewMedia={isChangePreviewMedia}
        />
      );

    default:
      return (
        <MediaOther
          media={media}
          swipeable={swipeable}
          slideDirection={slideDirection}
          isChangePreviewMedia={isChangePreviewMedia}
        />
      );
  }
};

export default MediaPreview;
